import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.png";

export const Banner = () => {
  //word animation state
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = [
    "Web Developer",
    "Web Designer",
    "Instructor",
    "Lifelong learner",
  ]; //later add a word in persian language
  const [text, setText] = useState("");
  const [setIndex] = useState(0);
  const [delta, setDelta] = useState(150); //measures how fast one letter comes after the first one is typed
  const [period] = useState(1000); //transition between each rotated word in (miliseconds?)

  //function to take care of typing and deleting text
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    }; //cleanup function for side effect
  });

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];

    if (isDeleting) {
      setText(fullText.substring(0, text.length - 1));
    } else {
      setText(fullText.substring(0, text.length + 1));
    }

    if (!isDeleting && text === fullText) {
      setDelta(period / 2); // this will reduce the pause duration by half
      setIsDeleting(true);
    } else if (isDeleting && text === "") {
      setIsDeleting(false);
      setLoopNum((prevLoopNum) => prevLoopNum + 1);
      setDelta(75); // this will make the deletion faster by a factor of 2
    }

    setIndex((prevIndex) => (prevIndex + 1) % fullText.length);
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <span className="tagline">Welcome to my Portfolio</span>
            <h1>{`Hi I'm Shirene `}</h1>
            <h1
              className="txt-rotate"
              torotate={[
                "Web Developer",
                "Web Designer",
                "Instructor",
                "Lifelong learner",
              ]}
            >
              {" "}
              <span className="wrap">{text}&nbsp;</span>
            </h1>
            {/* <span
                className="txt-rotate"
                torotate={[
                  "Web Developer",
                  "Web Designer",
                  "Instructor",
                  "Lifelong learner",
                ]}
              >
               
              </span> */}
            <p>
              I have a deep appreciation for the power of language, effective
              communication, and code, and I prioritize compassion and learning
              in all aspects of my life.
            </p>
            {/* <button onClick={() => console.log("connect")}>
              Let's connect <ArrowRightCircle size={25}></ArrowRightCircle>
            </button> */}
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Header Img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
